import APIClient from '@/shared/http/clients/api'

const resourceName = 'blocklist'
const APICore = process.env.APIBaseURLCore

const GetAllPaging = (limit, index, config = {}) => APIClient.get(`${APICore}/${resourceName}/?page=${index}&size=${limit}&sort=id,desc`, config)

const DeleteEmail = (id) => APIClient.delete(`${APICore}/${resourceName}/${id}`)

const Search = (filters, limit, index) => {
  let params = `?page=${index}&size=${limit}&sort=id,desc`
  if (filters.email) params += `&email=${filters.email}`
  if (filters.data) params += `&data=${filters.data}`
  return APIClient.get(`${APICore}/${resourceName}/${params}`)
}

const BlockListEmailRepository = {
  GetAllPaging,
  DeleteEmail,
  Search
}

export default BlockListEmailRepository



// WEBPACK FOOTER //
// ./src/shared/http/repositories/blocklist/blocklistEmail.js